import styled from 'styled-components'
import { COLOR } from '@fe/common/constants/main'

export const Separator = styled.hr<{ isForModal?: boolean }>`
  height: 1px;
  margin: ${({ isForModal }) =>
    isForModal ? '1rem -3rem 3rem' : '1rem 0 3rem'};
  background: ${COLOR.LIGHTER_GREY};
`
